var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StripePaymentForm',{attrs:{"email":_vm.email},on:{"submit":_vm.submitPayment,"cancel":function($event){_vm.currentStep = 3}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }